import { CONVERTER_COMMON_LANG } from "./common";
import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_IMPORT_LANG: {
  LIST_EMPTY_TITLE: MvnCodeFE;
  LIST_EMPTY_DESCRIPTION: MvnCodeFE;
  LIST_LABEL_SEQ: MvnCodeFE;
  LIST_LABEL_TYPE: MvnCodeFE;
  LIST_LABEL_FILE_NAME: MvnCodeFE;
  LIST_LABEL_CREATED: MvnCodeFE;
  LIST_LABEL_UPDATED: MvnCodeFE;
  LIST_LABEL_STATUS: MvnCodeFE;
  LIST_LABEL_SIZE: MvnCodeFE;
  LIST_MENU_DELETE: MvnCodeFE;
  LIST_FOOTER_BUTTON: MvnCodeFE;
  LIST_FOOTER_FILE_EXPLORER_BUTTON: MvnCodeFE;
  TOAST_FILE_UPLOAD_SUCCEED: MvnCodeFE;
  TOAST_FILE_UPLOAD_FAIL: MvnCodeFE;
  TOAST_FILE_DELETE_SUCCEED: MvnCodeFE;
  TOAST_FILE_DELETE_FAIL: MvnCodeFE;
  TOAST_GENERAL_FILE_UPLOAD_FAIL: MvnCodeFE;
  DIALOG_DELETE_TITLE: MvnCodeFE;
  DIALOG_DELETE_DESCRIPTION: MvnCodeFE;
  DIALOG_DELETE_USAGE_DESCRIPTION: MvnCodeFE;
  DIALOG_UNDELETABLE_ALERT_TITLE: MvnCodeFE;
  DIALOG_UNDELETABLE_ALERT_DESCRIPTION: MvnCodeFE;
  DIALOG_VALIDATION_ALERT_TITLE: MvnCodeFE;
  DIALOG_VALIDATION_ALERT_DESCRIPTION: MvnCodeFE;
  DIALOG_VALIDATION_ALERT_ALL_CHECKBOX: MvnCodeFE;
  DIALOG_VALIDATION_HELPER_TEXT: MvnCodeFE;
  DIALOG_CANCEL: MvnCodeFE;
  DIALOG_CONFIRM: MvnCodeFE;
  DIALOG_FILE_EXPLORER_TITLE: MvnCodeFE;
  DIALOG_FILE_EXPLORER_DELETE_TITLE: MvnCodeFE;
  DIALOG_FILE_EXPLORER_DELETE_DESCRIPTION: MvnCodeFE;
  DIALOG_FILE_EXPLORER_DELETE_SUCCEED: MvnCodeFE;
  DIALOG_FILE_EXPLORER_DELETE_FAIL: MvnCodeFE;
  DIALOG_FILE_EXPLORER_UPDATE_NAME_SUCCEED: MvnCodeFE;
  DIALOG_FILE_EXPLORER_UPDATE_NAME_FAIL: MvnCodeFE;
  DIALOG_FILE_EXPLORER_CANNOT_DELETE_ERROR: MvnCodeFE;
  DIALOG_FILE_EXPLORER_FILE_SELECTED: MvnCodeFE;
  RESOURCE_DOWNLOAD_FAIL: MvnCodeFE;
  FILE_EXPLORER_EMPTY_DATA: MvnCodeFE;
  FILE_EXPLORER_TABLE_HEADER_NAME: MvnCodeFE;
  FILE_EXPLORER_TABLE_HEADER_LAST_MODIFIED: MvnCodeFE;
  FILE_EXPLORER_TABLE_HEADER_TYPE: MvnCodeFE;
  FILE_EXPLORER_TABLE_HEADER_SIZE: MvnCodeFE;
  FILE_EXPLORER_TABLE_HEADER_ACTION: MvnCodeFE;
  FILE_UPLOAD_CANCEL: MvnCodeFE;
  FILE_UPLOAD_CONTINUE: MvnCodeFE;
  FILE_UPLOAD_CANCEL_DIALOG_MESSAGE: MvnCodeFE;

  FILE_VERB: MvnCodeFE;
  FILE_UPLOADING_VERB: MvnCodeFE;
  FILE_UPLOAD_READY_VERB: MvnCodeFE;
  FILE_UPLOAD_COMPLETED_VERB: MvnCodeFE;
} = {
  FILE_VERB: {
    ko: "파일",
    en: "file(s)",
  },

  FILE_UPLOADING_VERB: {
    ko: "업로드 중",
    en: "Uploading",
  },

  FILE_UPLOAD_READY_VERB: {
    ko: "업로드 준비",
    en: "Preparing for upload",
  },

  FILE_UPLOAD_COMPLETED_VERB: {
    ko: "업로드 완료",
    en: "Upload completed",
  },

  FILE_UPLOAD_CANCEL: {
    ko: "업로드 취소",
    en: "Cancel Upload",
  },
  FILE_UPLOAD_CONTINUE: {
    ko: "업로드 계속",
    en: "Continue Uploading",
  },
  FILE_UPLOAD_CANCEL_DIALOG_MESSAGE: {
    ko: "업로드가 완료되지 않았습니다.\n진행 중인 모든 업로드를 취소하시겠습니까?",
    en: "The upload has not been completed.\nAre you sure you want to cancel all ongoing uploads?",
  },
  LIST_EMPTY_TITLE: {
    ko: "사용할 수 있는 파일이 없습니다.",
    en: "File not found.",
  },
  LIST_EMPTY_DESCRIPTION: {
    ko: "추가 버튼을 눌러 파일을 업로드해 주세요.",
    en: "Press the Add button to upload the file(s).",
  },
  LIST_LABEL_SEQ: {
    ko: "No.",
    en: "No.",
  },
  LIST_LABEL_TYPE: {
    ko: "분류",
    en: "Type",
  },
  LIST_LABEL_FILE_NAME: {
    ko: "파일명",
    en: "File Name",
  },
  LIST_LABEL_CREATED: {
    ko: "최초 업로드 날짜/시간",
    en: "Initial upload Date/Time",
  },
  LIST_LABEL_UPDATED: {
    ko: "최근 업로드 날짜/시간",
    en: "Last uploaded Date/Time",
  },
  LIST_LABEL_STATUS: {
    ko: "상태",
    en: "Status",
  },
  LIST_LABEL_SIZE: {
    ko: "파일 용량",
    en: "Size",
  },
  LIST_MENU_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  LIST_FOOTER_BUTTON: CONVERTER_COMMON_LANG.ADD_VERB,

  LIST_FOOTER_FILE_EXPLORER_BUTTON: {
    ko: "파일 탐색기",
    en: "Browser",
  },

  TOAST_FILE_UPLOAD_SUCCEED: {
    ko: "{name} 파일 등록을 완료했습니다.",
    en: "{name} has been imported.",
  },
  TOAST_FILE_UPLOAD_FAIL: {
    ko: "{name} 파일 등록에 실패했습니다.",
    en: "Failed to import {name}",
  },
  TOAST_GENERAL_FILE_UPLOAD_FAIL: {
    ko: "파일 등록에 실패했습니다.",
    en: "Failed to import",
  },
  TOAST_FILE_DELETE_SUCCEED: {
    ko: "파일을 삭제했습니다.",
    en: "The file has been deleted.",
  },
  TOAST_FILE_DELETE_FAIL: {
    ko: "파일 삭제에 실패했습니다.",
    en: "Failed to delete the file.",
  },
  DIALOG_DELETE_TITLE: {
    ko: "삭제 확인",
    en: "Confirm Deletion",
  },
  DIALOG_DELETE_DESCRIPTION: {
    ko: "파일을 삭제하시겠습니까?",
    en: "Confirm deletion of the file?",
  },
  DIALOG_DELETE_USAGE_DESCRIPTION: {
    ko: "삭제 대상 파일(들)이 아래 흐름에서 사용되고 있습니다.\n\n파일을 삭제하실 경우 해당 흐름을 재 수행해야 하며, 흐름에 오류가 발생할 수 있습니다.\n해당 파일을 삭제 하시겠습니까?",
    en: "The file(s) you are trying to delete are used in the following flow(s).\nDeleting them will require re-running the flows and may cause errors.\nDo you want to proceed with deletion?",
  },
  DIALOG_UNDELETABLE_ALERT_TITLE: {
    ko: "삭제 불가",
    en: "Deletion Not Allowed",
  },
  DIALOG_UNDELETABLE_ALERT_DESCRIPTION: {
    ko: "현재 사용중인 파일이므로 삭제할 수 없습니다.",
    en: "The file is currently in use and cannot be deleted.",
  },
  DIALOG_VALIDATION_ALERT_TITLE: {
    ko: "파일 업로드 경고",
    en: "File Upload Warning",
  },
  DIALOG_VALIDATION_ALERT_DESCRIPTION: {
    ko: "중복파일 및 형식에 맞지 않는 파일 목록을 확인해 주시기 바랍니다.",
    en: "Please review the list of duplicate files and files with incompatible formats.",
  },
  DIALOG_VALIDATION_ALERT_ALL_CHECKBOX: {
    ko: "중복파일 모두 덮어쓰기",
    en: "Replace all duplicate files",
  },
  DIALOG_VALIDATION_HELPER_TEXT: {
    ko: "파일 형식이 적합하지 않습니다.",
    en: "The file format is incompatible.",
  },
  DIALOG_FILE_EXPLORER_TITLE: {
    ko: "파일 탐색기",
    en: "Browser",
  },
  DIALOG_FILE_EXPLORER_DELETE_TITLE: {
    ko: "삭제",
    en: "Delete",
  },
  DIALOG_FILE_EXPLORER_DELETE_DESCRIPTION: {
    ko: "파일 삭제 후 복구가 불가능합니다.\n파일을 삭제하시겠습니까?",
    en: "re you sure you want to delete this file?\nThis action cannot be undone.",
  },
  DIALOG_FILE_EXPLORER_DELETE_SUCCEED: {
    ko: "파일을 삭제했습니다.",
    en: "The file has been deleted.",
  },
  DIALOG_FILE_EXPLORER_DELETE_FAIL: {
    ko: "파일 삭제에 실패했습니다.",
    en: "Failed to delete the file.",
  },
  DIALOG_FILE_EXPLORER_UPDATE_NAME_SUCCEED: {
    ko: "이름변경을 완료했습니다.",
    en: "The name has been changed.",
  },
  DIALOG_FILE_EXPLORER_UPDATE_NAME_FAIL: {
    ko: "이름변경에 실패했습니다.",
    en: "Failed to change the name.",
  },
  DIALOG_FILE_EXPLORER_CANNOT_DELETE_ERROR: {
    ko: "이 파일은 다른 흐름에서 참조되고 있어 삭제할 수 없습니다.",
    en: "This file cannot be deleted as it is referenced in another flow.",
  },
  DIALOG_FILE_EXPLORER_FILE_SELECTED: {
    ko: "개 선택됨",
    en: " items selected.",
  },
  RESOURCE_DOWNLOAD_FAIL: {
    ko: "다운로드에 실패했습니다.",
    en: "Download has been failed",
  },
  FILE_EXPLORER_EMPTY_DATA: {
    ko: "데이터가 없습니다.",
    en: "There is no data.",
  },
  FILE_EXPLORER_TABLE_HEADER_NAME: {
    ko: "이름",
    en: "Name",
  },
  FILE_EXPLORER_TABLE_HEADER_LAST_MODIFIED: {
    ko: "수정한 날짜",
    en: "Updated at",
  },
  FILE_EXPLORER_TABLE_HEADER_TYPE: {
    ko: "유형",
    en: "Type",
  },
  FILE_EXPLORER_TABLE_HEADER_SIZE: {
    ko: "파일용량",
    en: "Size",
  },
  FILE_EXPLORER_TABLE_HEADER_ACTION: {
    ko: "작업",
    en: "Action",
  },

  DIALOG_CONFIRM: CONVERTER_COMMON_LANG.CONFIRM_VERB,
  DIALOG_CANCEL: CONVERTER_COMMON_LANG.CANCEL_VERB,
};

MvnCodeInitiate(CONVERTER_STUDY_IMPORT_LANG);
